<template>
    <div class="survey-question card"
         @mouseover="onMouseOver"
         @mouseout="onMouseOut">
        <div class="card-content">
            <p class="handle has-text-centered"
                v-visible="model.header || isHover">
                <b-icon icon="drag-horizontal"></b-icon>
            </p>

            <div class="columns" v-visible="model.header || isHover">
                <div class="column">
                    <template>
                        <b-input
                            maxlength="500"
                            :has-counter="false"
                            placeholder="Верхний колонтитул"
                            v-model.trim="model.header"/>
                    </template>
                </div>
            </div>

            <div class="columns">
                <div class="column model-title">
                    <div class="control"
                         :class="{
                             'is-loading': loading
                         }">
                        <textarea-autosize
                            class="textarea"
                            :class="{
                                'is-danger': model.title
                                    ? model.title.length == 0 : true
                            }"
                            maxlength="1000"
                            placeholder="Текст вопроса"
                            v-model.trim="model.title"/>
                    </div>
                </div>
                <div class="column is-one-quarter">
                    <b-field>
                        <b-select
                            ref="typeSelect"
                            expanded
                            :disabled="survey.published == true"
                            @input="type => onTypeChange(type)"
                            :value="model.type">
                            <option
                                v-for="type in types"
                                :value="type"
                                :key="type">
                                {{ $t(`surveys.question.type.${type}`) }}
                            </option>
                            <template v-if="survey.is_quiz == false">
                                <option disabled>
                                    {{ $t(`surveys.question.generated`) }}
                                </option>
                                <option
                                    v-for="type in generatedTypes"
                                    :value="type"
                                    :key="type">
                                    {{ $t(`surveys.question.type.${type}`) }}
                                </option>
                            </template>
                        </b-select>
                    </b-field>
                    <b-field v-if="survey.is_quiz == false">
                        <b-switch
                            v-model="model.required">
                            Обязательно
                        </b-switch>
                    </b-field>
                    <b-field v-visible="isHover" v-if="!survey.published" grouped>
                        <div class="control is-expanded">
                            <button
                                class="button is-fullwidth is-danger is-outlined"
                                @click="remove">
                                <b-icon icon="delete"></b-icon>
                            </button>
                        </div>
                        <div class="control is-expanded">
                            <button
                                class="button is-fullwidth is-primary is-outlined"
                                @click="duplicate">
                                <b-icon icon="content-copy"></b-icon>
                            </button>
                        </div>
                    </b-field>
                </div>
            </div>

    <div class="columns">
        <div class="column">

            <template v-if="model.type == 'radio' || model.type == 'checkbox'">
                <b-field
                    v-for="option in model.options"
                    :key="option.uuid"
                    grouped>
                    <b-radio
                        disabled
                        :native-value="null"
                        v-if="model.type == 'radio'"/>
                    <b-checkbox
                        disabled
                        v-if="model.type == 'checkbox'"/>
                    <b-input expanded
                             v-model="option.title">
                    </b-input>
                    <template v-if="survey.is_quiz">
                        <button class="button"
                            :class="{
                                'is-success': option.correct,
                                'is-outlined': !option.correct,
                            }"
                            @click="switchOptionCorrect(option.uuid)">
                            <span class="is-hidden-tablet">
                                <b-icon icon="check" size="is-small"/>
                            </span>
                            <span class="is-hidden-mobile">Верный вариант</span>
                        </button>
                        &nbsp;
                        &nbsp;
                    </template>
                    <button class="button is-danger is-outlined"
                        v-if="!survey.published"
                        @click="removeOption(option.uuid)">
                        <span class="is-hidden-tablet">
                            <b-icon icon="delete" size="is-small"></b-icon>
                        </span>
                        <span class="is-hidden-mobile">Удалить</span>
                    </button>
                </b-field>
                
        <div class="columns">
            <div class="column is-one-third" v-if="!survey.published">
                <b-field grouped>
                    <b-radio
                        disabled
                        :native-value="null"
                        v-if="model.type == 'radio'"/>
                    <b-checkbox
                        disabled
                        v-else/>
                    <div class="control">
                        <button class="button"
                            @click="addOption">
                            <b-icon icon="plus" size="is-small"></b-icon>
                            <span>Добавить ответ</span>
                        </button>
                    </div>
                </b-field>
            </div>
            <div class="column" v-if="model.type == 'checkbox'">
                <b-field grouped>
                    <b-field style="margin: 0">
                        <label style="line-height: 2.25em;">Тип ответа</label>
                    </b-field>
                    <b-field expanded>
                        <b-select
                            v-model="model.answer_type"
                            expanded>
                            <option value="full">
                                Полное соответсвие
                            </option>
                            <option value="partial">
                                Частичное соответсвие (только правильные)
                            </option>
                            <option value="partial_any">
                                Частичное соответсвие (включая неправильные)
                            </option>
                        </b-select>
                    </b-field>
                </b-field>
            </div>
        </div>
                
                <div class="message is-danger"
                    v-if="(model.type == 'radio' || model.type == 'checkbox') && !hasAnswers && survey.is_quiz">
                    <div class="message-body">
                        В данном вопросе отсутствуют <b>верные варианты</b> ответа.
                        Полное выполнение теста будет невозможно.
                    </div>
                </div>

                <template v-if="!survey.is_quiz">
                    <b-field grouped>
                        <div class="control">
                            <b-checkbox
                                @input="onUpdate"
                                v-model="model.other">
                                Вариант "Другое"
                            </b-checkbox>
                        </div>
                    </b-field>

                    <b-field grouped>
                        <div class="control">
                            <b-checkbox
                                @input="onUpdate"
                                v-model="model.comment">
                                Комментарий
                            </b-checkbox>
                        </div>
                    </b-field>

                    <b-field grouped v-if="model.type == 'radio'">
                        <div class="control">
                            <b-checkbox
                                @input="onUpdate"
                                v-model="model.filter">
                                Фильтр
                            </b-checkbox>
                        </div>
                    </b-field>
                </template>
            </template>
            <template v-else-if="model.type == 'text'">
                <textarea-autosize
                    class="textarea"
                    maxlength="2000"
                    placeholder="Шаблон ответа (необязательно)"
                    v-model.trim="model.placeholder"/>
            </template>
            <template v-else-if="model.type == 'short'">
                <b-input disabled/>
            </template>
            <template v-else-if="isGeneratedQuestion">
                <div class="message is-info">
                    <div class="message-body">
                        Для данного вопроса варианты ответа будут сгенерированы <b>автоматически</b>
                        на основании данных студента.
                    </div>
                </div>

                <b-field grouped>
                    <div class="control">
                        <b-checkbox
                            @input="onUpdate"
                            v-model="model.comment">
                            Комментарий
                        </b-checkbox>
                    </div>
                </b-field>

                <b-field grouped>
                    <div class="control">
                        <b-checkbox
                            @input="onUpdate"
                            v-model="model.filter">
                            Фильтр
                        </b-checkbox>
                    </div>
                </b-field>
            </template>
        </div>
    </div>

            <div class="columns" v-visible="model.footer || isHover">
                <div class="column">
                    <template>
                        <b-input
                            maxlength="500"
                            :has-counter="false"
                            placeholder="Нижний колонтитул"
                            v-model.trim="model.footer"/>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<style scope>
.model-title textarea {
  min-height: 124px !important;
}
</style>

<script>
import uuid from "uuid/v4";
import toasts from "../mixins/toasts";

export default Vue.extend({
  props: {
    survey: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  mixins: [toasts],
  data() {
    return {
      mouseOver: false,
      types: ["radio", "checkbox", "text", "short"],
      generatedTypes: ["generated-courses"],
      loading: false,
      model: this.value
    };
  },
  created() {
    this.model.exists = this.model.uuid != null;

    // If model doesn't exist in the storage, send request to store it.
    if (!this.model.exists) {
      this.model.uuid = uuid();
      this.model.answer_type = "full";

      if (this.model.options) {
        this.model.options = JSON.parse(JSON.stringify(this.model.options));
      }

      this.loading = true;

      return axios
        .post(`/api/surveys/${this.survey.id}/questions`, this.model)
        .then(response => {
          this.model = response.data;
          this.model.exists = true;
          this.$emit("created");
        })
        .finally(_ => {
          this.loading = false;
        });
    }

    // if (!this.model.options) {
    //   this.model.options = [];
    // }
  },
  watch: {
    model: {
      deep: true,
      handler: "onUpdate"
    }
  },
  computed: {
    isGeneratedQuestion() {
        return this.generatedTypes.indexOf(this.model.type) > -1;
    },
    hasAnswers() {
      if (
        (this.model.type == "radio" || this.model.type == "checkbox") &&
        this.model.options
      ) {
        return _.findIndex(this.model.options, { correct: true }) > -1;
      }

      return false;
    },
    isHover() {
      // Either mouse over or small screen
      return this.mouseOver || window.innerWidth < 770;
    },
    onUpdate() {
      return _.debounce(this.update, 1000);
    }
  },
  methods: {
    onTypeChange(type) {
      let old_type = this.model.type;

      if (
        (old_type == "radio" || old_type == "checkbox") &&
        (type == "text" || type == "short") &&
        this.model.options &&
        this.model.options.length > 0
      ) {
        this.$dialog.confirm({
          title: "Изменение типа вопроса",
          message:
            `Вы собираетесь поменять тип вопроса с вариантами ` +
            `ответа на вопрос с текстовым ответом. ` +
            `Это действие удалит ранее созданные варианты ответа.`,
          confirmText: "Продолжить",
          cancelText: "Отмена",
          type: "is-warning",
          hasIcon: true,
          onConfirm: () => {
            this.model.type = type;
            this.model.options = [];
            this.model.answer_type = "full";
          },
          onCancel: () => {
            this.model.type = old_type;
            // Force update buefy component selection.
            this.$refs.typeSelect.$data.selected = old_type;
          }
        });
      } else {
        this.model.type = type;

        if (type == "radio" || type == "checkbox") {
          if (!this.model.options) {
            this.model = Object.assign({}, this.model, {
              options: [],
            });
          }

          if (!this.model.answer_type) {
            this.model = Object.assign({}, this.model, {
              answer_type: "full",
            });
          }
        }
      }
    },
    onMouseOver() {
      this.mouseOver = true;
    },
    onMouseOut() {
      this.mouseOver = false;
    },
    update(data) {
      if (!this.model.exists) {
        return;
      }

      this.loading = true;

      axios
        .put(
          `/api/surveys/${this.survey.id}/questions/${this.model.uuid}`,
          _.merge(this.model, data)
        )
        .catch(error => {
          switch (error.response.status) {
            case 422: {
              let data = error.response.data;
              let errors = data.errors;
              let errorKeys = Object.keys(errors);

              if (errorKeys.length > 0) {
                this.toast("error", errors[errorKeys[0]][0]);
              } else {
                this.toast("error", data.message);
              }
              break;
            }
            default: {
              this.toast("error", "@unexpected", error);
              break;
            }
          }
        })
        .finally(__ => {
          _.delay(__ => {
            this.loading = false;
          }, 200);
        });
    },
    remove() {
      this.$emit("remove", this.model);
    },
    duplicate() {
      this.$emit("duplicate", this.model);
    },
    addOption() {
      let option = {
        uuid: uuid(),
        title: "",
        correct: false
      };

      if (!this.model.options) {
        this.model.options = [];
      }

      this.model.options.push(option);

      this.$forceUpdate();
    },
    switchOptionCorrect(uuid) {
      let index = _.findIndex(this.model.options, {
        uuid: uuid
      });

      this.model.options.splice(
        index,
        1,
        _.merge(this.model.options[index], {
          correct: !_.get(this.model.options[index], "correct", false)
        })
      );
    },
    removeOption(uuid) {
      this.model.options.splice(
        _.findIndex(this.model.options, {
          uuid: uuid
        }),
        1
      );
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/survey/Question.vue